import React, { Component } from 'react'
import { toast } from 'react-toastify'
import $ from 'jquery'
// component
import Toaster from '../Toaster/Toaster'
import agent from '../../api/Api'
import { trackPageView, trackTimeSpent, trackFormConfusion } from '../../utils/Analytics'
import config from '../../config/config'
// css
import './MyCode.css'

class MyCode extends Component {
  constructor (props) {
    super(props)
    this.state = {
      userInfo: {},
      teacherCodeList: [],
      codeName: '',
      errorCount: {
        codeName: 0
      }
    }
    this.handleGetTeacherCodeList = this.handleGetTeacherCodeList.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.fieldTimers = {};
  }

  handleGetTeacherCodeList (email) {
    let url = '/teacher/getAllTeacherCodesById?email=' + email
    agent.APILIST.getMask(url)
      .then(res => {
        if (res.status === 'SUCCESS') {
          var temp = res.codeWithName ? res.codeWithName : {}
          var defaultCode = { Default: res.teacherCode }
          var newTemp = $.extend(defaultCode, temp)
          this.setState({ teacherCodeList: newTemp })
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  handleInputChange (event) {
    const { name, value } = event.target
    let re = /^[a-zA-Z\b]+$/
    if (re.test(value) || value === '') this.setState({ [name]: value })
    if (value.length > 0) {
      $('#' + name).css({ border: '1px solid #ddd' })
    } else {
      $('#' + name).css({ border: '1px solid red' })
      this.setState(prev => ({
        errorCount: {
          ...prev.errorCount,
          codeName: (prev.errorCount?.codeName || 0) + 1
        }
      }), () => {
        if (this.state.errorCount?.codeName >= config.ERROR_COUNT) {
          trackFormConfusion('My Codes', 'code name');
        }
      });
    }
  }

  handleFocus = (field) => {
    this.fieldTimers[field] = Date.now();
  };

  handleBlur = (field) => {
    if (this.fieldTimers[field]) {
      const duration = (Date.now() - this.fieldTimers[field]) / 1000;
      if (duration > config.FOCUS_TIME) {
        trackFormConfusion('My Codes', 'code name', duration);
      }
      delete this.fieldTimers[field];
    }
  };

  handleSubmit () {
    $('#loader').fadeIn()
    let param = {
      codeName: this.state.codeName
    }

    let count = 0
    for (var key in param) {
      if (param[key]) {
        $('#' + key).css({ border: '1px solid #ddd' })
        count += 1
      } else {
        $('#' + key).css({ border: '1px solid red' })
        this.setState(prev => ({
          errorCount: {
            ...prev.errorCount,
            codeName: (prev.errorCount?.codeName || 0) + 1
          }
        }), () => {
          if (this.state.errorCount?.codeName >= config.ERROR_COUNT) {
            trackFormConfusion('My Codes', 'code name');
          }
        });
      }
    }

    console.log(count)
    if (count === 1) {
      const url = '/teacher/getNewCode?email=' + this.state.userInfo.email + '&codeName=' + this.state.codeName
      agent.APILIST.getMask(url)
        .then(res => {
          if (res.status === 'SUCCESS') {
            console.log(res.status);
            this.setState({ codeName: '' })
            toast.dismiss()
            toast(<Toaster title='Teacher Code' content={res.message} status='success' />)
            $('#loader').fadeOut()
            this.handleGetTeacherCodeList(this.state.userInfo.email)
          }
        })
        .catch(err => {
          $('#loader').fadeOut()
          console.log(err.response.text)
          let res = JSON.parse(err.response.text)
          toast.dismiss()
          toast(<Toaster title='My code' content={res.message} status='error' />)
          setTimeout(function () { toast.dismiss() }, 3000)
        })
    } else {
      window.scrollTo(0, 0)
      $('#loader').fadeOut()
    }
  }

  componentDidMount () {
    trackPageView('/my-codes');
    this.startTime = Date.now();
    this.currentPath = window.location.href;
    var loginCheck = JSON.parse(localStorage.getItem('userInfo'))
    if (loginCheck) {
      this.setState({ userInfo: loginCheck })
      this.handleGetTeacherCodeList(loginCheck.email)
    }
  }

  copyToClipboard (id) {
    let referralUrl = window.location.origin + '/teacherrefer/'+id
    navigator.clipboard.writeText(referralUrl)
    toast(<Toaster title='My Codes' content="Teacher referral code copied to clip board!" status='success'/>)
    setTimeout(function () { toast.dismiss() }, 2000)
  }

  componentWillUnmount() {
      trackTimeSpent('/my-codes', this.currentPath, this.startTime);
  }

  render () {
    return (
      <div id='mycode'>
        <div className='mycode-outer-blk noselect'>
          <div className='mycode-blk'>
            <div className='title-blk'>
              <p className='mycode-title'>My Codes</p>
            </div>
            <div className='code-form'>
              <input type='text' name='codeName' id='codeName' maxLength='20' onChange={this.handleInputChange} placeholder='Enter code name' value={this.state.codeName} onFocus={() => this.handleFocus('codeName')} onBlur={() => this.handleBlur('codeName')} />
              <div className='generate-blk' onClick={this.handleSubmit}>
                <p className='generate-btn'>generate code</p>
              </div>
            </div>
            <div className='table-outer'>
              <table>
                <thead>
                  <tr><th>Code Names</th><th>Codes</th><th></th></tr>
                </thead>
                <tbody>
                  {Object.keys(this.state.teacherCodeList).map((key, i) => (
                    <tr key={i}>
                      <td>{key}</td>
                      <td>{this.state.teacherCodeList[key]}</td>
                      <td style={{display:'flex',justifyContent:'flex-end'}}>
                        <button onClick={()=>this.copyToClipboard(this.state.teacherCodeList[key])} 
                          class="copy-clipboard">
                          Referral Link
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    )
  }
}

export default MyCode
